<template>
    <div class="action-buttons footer" v-if="$route.name !== 'removeData'">
        <button class="button" @click="logOut()">Log out</button>
        <div class="footer-last-modified"><b>Last update:</b> {{ lastModified }}</div>
        <div class="footer-last-modified"><b>App version:</b> {{ BUILD_COMMIT }}</div>
        <div v-if="dataWarning" class="footer-data-warning" :title="dataWarning">⚠ {{ dataWarning }}</div>
        <session-expired-modal v-if="error" @relogin="relogin()" />
    </div>
</template>
<script>
import moment from 'moment';
import * as Sentry from "@sentry/browser";
import { msalClient } from '@/login';
import FileFetcher from '@/FileFetcher';
import globals from '@/globals';
import SessionExpiredModal from '@/components/SessionExpiredModal.vue';

export default {
    components: { SessionExpiredModal },
    data() {
        return {
            BUILD_COMMIT,
            FileFetcher
        };
    },
    methods: {
        clearLocalStorage() {
            Object.keys(localStorage).forEach(key => delete localStorage[key]);
        },
        async logOut() {
            this.clearLocalStorage();
            Sentry.setUser(null); // no-op when Sentry has no DSN configured
            msalClient.logoutRedirect();
        },
        relogin() {
            this.clearLocalStorage();
            location.href = '#/login';
        }
    },
    computed: {
        lastModified() {
            if (!this.FileFetcher.lastModifiedDateTime) {
                return 'N/A';
            } else {
                return moment(this.FileFetcher.lastModifiedDateTime).format('D MMM YYYY [at] h:mm:ss a');
            }
        },
        error() {
            //don't show an error telling the user to log in,
            //if they are are already on the login page
            if (this.$route.name === 'login')
                return null;
            return globals.error;
        },
        dataWarning() {
            return globals.dataWarning;
        }
    }
}
</script>
<style>


.action-buttons.footer {
    bottom: 0;
    width: 100%;
    flex-direction: column;
}

.footer-last-modified {
    font-size: 12px;
    color: #777;
    pointer-events: none;
}

.footer-data-warning {
    font-size: 12px;
    color: #8a5a00;
    background: #fff4d6;
    border: 1px solid #f0d48a;
    border-radius: 4px;
    padding: 2px 8px;
    margin-top: 4px;
    max-width: 90vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>